export default {
  en: {
    title: 'Live monitor',
    betaAlert: 'Welcome to the new live monitor in beta status! We want to hear your suggestions in the feedback section',
    emptyQueue: 'No customers in the queue',
    queueTitle: 'Enqueued customers',
    agentsInCall: 'In call agents',
    filter: {
      segments: 'Segments',
      agents: 'Agents',
      search: 'Search agent...',
      reset: 'Clear',
      top: 'Top {count} UV',
      topTooltip: 'Show only the {count} most stressed segments ordered by UV scale',
      inverseSegments: 'Invert segment selection',
      inverseSegmentsActive: 'Excluding selected segments',
    },
    views: {
      title: 'Saved views',
      placeholder: 'Saved views',
      empty: 'No saved views yet',
      modified: 'Modified',
      save: 'Save as new view',
      update: 'Update current view',
      edit: 'Edit view',
      editTitle: 'Edit saved view',
      rename: 'Rename',
      nameField: 'Name',
      replaceFilters: 'Replace this view\'s filters with the current ones',
      filtersIdentical: 'Current filters are identical to those of this view.',
      saveChanges: 'Save changes',
      delete: 'Delete',
      namePrompt: 'Name your view',
      namePlaceholder: 'e.g. Critical queues',
      confirmDelete: 'Delete view "{name}"?',
      saved: 'View "{name}" saved',
      updated: 'View "{name}" updated',
      deleted: 'View "{name}" deleted',
      loadError: 'Could not load saved views',
      saveError: 'Could not save view',
      incompatible: 'This view was saved by a newer version and may not load completely',
    },
    detail: {
      label: 'Expand:',
      agents: 'Agents',
      queues: 'Queues',
      calls: 'Calls',
    },
    sort: {
      placeholder: 'Sort by',
      available: 'Available',
      waiting: 'In queue',
      inCall: 'In call',
      acw: 'ACW',
      occupied: 'Occupied',
      online: 'Online',
      offline: 'Offline',
      total: 'Total agents',
      asc: 'Ascending',
      desc: 'Descending',
    },
    status: {
      live: 'Live',
      disconnected: 'Disconnected',
    },
    center: 'Center monitor',
    close: 'Minimize',
    theme: { dark: 'Dark mode', light: 'Light mode' },
    fullscreen: { enter: 'Enter fullscreen', exit: 'Exit fullscreen' },
  },
  es: {
    title: 'Monitor en vivo',
    betaAlert: '¡Bienvenido al nuevo monitor en vivo en estado beta! Queremos escuchar tus sugerencias en la sección de comentarios',
    emptyQueue: 'No hay clientes en la fila',
    queueTitle: 'Clientes en cola',
    agentsInCall: 'Agentes en llamada',
    filter: {
      segments: 'Segmentos',
      agents: 'Agentes',
      search: 'Buscar agente...',
      reset: 'Limpiar',
      top: 'Top {count} UV',
      topTooltip: 'Mostrar solo los {count} segmentos más estresados ordenados por escala UV',
      inverseSegments: 'Invertir selección de segmentos',
      inverseSegmentsActive: 'Excluyendo segmentos seleccionados',
    },
    views: {
      title: 'Vistas guardadas',
      placeholder: 'Vistas guardadas',
      empty: 'No hay vistas guardadas',
      modified: 'Modificada',
      save: 'Guardar como nueva vista',
      update: 'Sobrescribir vista actual',
      edit: 'Editar vista',
      editTitle: 'Editar vista guardada',
      rename: 'Renombrar',
      nameField: 'Nombre',
      replaceFilters: 'Reemplazar los filtros de esta vista con los actuales',
      filtersIdentical: 'Los filtros actuales son idénticos a los de esta vista.',
      saveChanges: 'Guardar cambios',
      delete: 'Eliminar',
      namePrompt: 'Nombre de la vista',
      namePlaceholder: 'ej. Filas críticas',
      confirmDelete: '¿Eliminar la vista "{name}"?',
      saved: 'Vista "{name}" guardada',
      updated: 'Vista "{name}" actualizada',
      deleted: 'Vista "{name}" eliminada',
      loadError: 'No se pudieron cargar las vistas guardadas',
      saveError: 'No se pudo guardar la vista',
      incompatible: 'Esta vista fue guardada por una versión más nueva y podría no cargar completamente',
    },
    detail: {
      label: 'Desplegar:',
      agents: 'Agentes',
      queues: 'Filas',
      calls: 'Llamadas',
    },
    sort: {
      placeholder: 'Ordenar por',
      available: 'Disponibles',
      waiting: 'En cola',
      inCall: 'En llamada',
      acw: 'ACW',
      occupied: 'Ocupados',
      online: 'Online',
      offline: 'Offline',
      total: 'Total agentes',
      asc: 'Ascendente',
      desc: 'Descendente',
    },
    status: {
      live: 'En vivo',
      disconnected: 'Desconectado',
    },
    center: 'Centrar monitor',
    close: 'Minimizar',
    theme: { dark: 'Modo oscuro', light: 'Modo claro' },
    fullscreen: { enter: 'Pantalla completa', exit: 'Salir de pantalla completa' },
  },
  fr: {
    title: 'Moniteur en direct',
    betaAlert: 'Bienvenue sur le nouveau moniteur en direct en phase bêta ! Nous souhaitons connaître vos suggestions dans la section des commentaires',
    emptyQueue: 'Aucun client dans la file d\'attente',
    queueTitle: 'Clients en attente',
    agentsInCall: 'Agents en appel',
    filter: {
      segments: 'Segments',
      agents: 'Agents',
      search: 'Chercher un agent...',
      reset: 'Effacer',
      top: 'Top {count} UV',
      topTooltip: 'Afficher uniquement les {count} segments les plus stressés selon l\'échelle UV',
      inverseSegments: 'Inverser la sélection des segments',
      inverseSegmentsActive: 'Exclusion des segments sélectionnés',
    },
    views: {
      title: 'Vues enregistrées',
      placeholder: 'Vues enregistrées',
      empty: 'Aucune vue enregistrée',
      modified: 'Modifiée',
      save: 'Enregistrer comme nouvelle vue',
      update: 'Mettre à jour la vue actuelle',
      edit: 'Modifier la vue',
      editTitle: 'Modifier la vue enregistrée',
      rename: 'Renommer',
      nameField: 'Nom',
      replaceFilters: 'Remplacer les filtres de cette vue par les filtres actuels',
      filtersIdentical: 'Les filtres actuels sont identiques à ceux de cette vue.',
      saveChanges: 'Enregistrer les modifications',
      delete: 'Supprimer',
      namePrompt: 'Nommez votre vue',
      namePlaceholder: 'ex. Files critiques',
      confirmDelete: 'Supprimer la vue « {name} » ?',
      saved: 'Vue « {name} » enregistrée',
      updated: 'Vue « {name} » mise à jour',
      deleted: 'Vue « {name} » supprimée',
      loadError: 'Impossible de charger les vues enregistrées',
      saveError: 'Impossible d\'enregistrer la vue',
      incompatible: 'Cette vue a été enregistrée par une version plus récente et pourrait ne pas se charger complètement',
    },
    detail: {
      label: 'Développer :',
      agents: 'Agents',
      queues: 'Files',
      calls: 'Appels',
    },
    sort: {
      placeholder: 'Trier par',
      available: 'Disponibles',
      waiting: 'En attente',
      inCall: 'En appel',
      acw: 'ACW',
      occupied: 'Occupés',
      online: 'En ligne',
      offline: 'Hors ligne',
      total: 'Total agents',
      asc: 'Croissant',
      desc: 'Décroissant',
    },
    status: {
      live: 'En direct',
      disconnected: 'Déconnecté',
    },
    center: 'Centrer le moniteur',
    close: 'Réduire',
    theme: { dark: 'Mode sombre', light: 'Mode clair' },
    fullscreen: { enter: 'Plein écran', exit: 'Quitter le plein écran' },
  },
};
